import React from 'react';
import { H3 } from '../heading/Heading';
import { P } from '../paragraph/Paragraph';
import { LoadingIcon, LargeLoadingIcon, MeijerIcon } from './Icon-loading';
import './Loading.scss';

interface LoadingProps {
  detail?: string | boolean;
  smallHorizontal?: boolean;
  small?: string | boolean;
  title?: string | boolean;
}

export const Loading: React.FC<LoadingProps> = ({
  detail,
  smallHorizontal,
  small,
  title
}) => {
  return (
    <div
      className={`ads-loading ${
        smallHorizontal ? 'ads-loading--horizontal' : ''
      }`}
      data-testid="ads-loading"
    >
      {small ? (
        <div
          className="ads-loading__icon"
          role="alert"
          aria-busy="true"
          data-testid="ads-loading--small"
        >
          <LoadingIcon />
        </div>
      ) : smallHorizontal ? (
        <div
          className="ads-loading__icon"
          role="alert"
          aria-busy="true"
          data-testid="ads-loading--small"
        >
          <LoadingIcon />
        </div>
      ) : (
        <div className="ads-loading__large-icon--container">
          <div
            className="ads-loading__large-icon"
            data-testid="ads-loading--large"
            role="alert"
            aria-busy="true"
          >
            <LargeLoadingIcon />
          </div>
          <span className="ads-loading__large-icon--meijer">
            <MeijerIcon />
          </span>
        </div>
      )}
      {title && <H3 type="heading-06 (20)">{title}</H3>}
      {detail && <P>{detail}</P>}
    </div>
  );
};
